export default function codeGenerator(taille) {
  const uid = taille.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) % 16 | 0;
    return (c == "x" ? r : r & (0x2 | 0x8)).toString(16);
  });
  return uid;
}
